import { Route, Routes as RoutesContainer } from "react-router";
import { Competitions, Register } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/' element={<Competitions />} />
      <Route exact path='/competition/register/:slug' element={<Register />} />
    </RoutesContainer>
  );
};
export default Routes;
